import React from "react";
import { TicketsTopicsPage } from "./TicketsTopicsPage";
import { useTicketsTopics } from "./useTicketsTopics";

function TicketsTopics() {
  return <TicketsTopicsPage {...useTicketsTopics()} />;
}

export default TicketsTopics;
